export default "__VITE_ASSET__6edbc226__"